/** Zod validation schemas for Search Analytics endpoints */

import { z } from 'zod'

export const searchAnalyticsQuerySchema = z.object({
  days: z.coerce.number().int().min(1).max(90).default(30).optional(),
  limit: z.coerce.number().int().min(1).max(100).default(20).optional(),
})

export const recordSearchClickSchema = z.object({
  queryId: z.string().min(1),
  documentId: z.string().min(1),
  position: z.number().int().min(0),
})
